<template>
    <div class="media" :class="{'active': isActive}">
        <div class="media-left">
            <img :src="thumbnail" class="media-object rounded" style="object-fit: cover; height: 60px"/>
        </div>
        <div class="media-body">
            <a v-text="truncatedTitle" @click="$emit('selected')"></a><br>
            <span class="text-muted"><small class="tw-mr-4">{{ formattedUploadedAt }}</small><small>{{ duration }}</small></span><br>
            <span class="text-muted">{{$t('wi.now_playing')}}</span>
        </div>
        <div v-show="false">
            <video ref="video" :src="src"></video>
        </div>
    </div>
</template>

<script>
import { moment, format } from "../../../moment";

export default {
  name: "PlayListItem",
  data() {
    return {
      duration: '...'
    }
  },
  props: {
    thumbnail: {required: true, type: String},
    title: {required: true, type: String},
    isActive: {default: false},
    id: {type: Number},
    src: {required: true, type: String},
    uploadedAt: {required: true, type: String}
  },
  computed: {
    truncatedTitle() {
      return this.title.substring(0, 25) + (this.title.length > 25 ? ' ...' : '');
    },
    formattedUploadedAt() {
      return moment(this.uploadedAt).format(format.date)
    }
  },
  methods: {
    updateVideoDuration() {
      let video = this.$refs.video;

      video.addEventListener('durationchange',  () => {
        if (video.readyState){
            let duration = Math.floor(video.duration);
            let minutes = ('0' + parseInt(duration / 60, 10)).slice(-2);
            let seconds = ('0' + (duration % 60)).slice(-2);
            this.duration = `${minutes}:${seconds}`;
        }
      });
    }
  },
  mounted() {
    this.updateVideoDuration();
  }
}
</script>

<style scoped>

</style>
